export default {
    messages: {
        "navbar.links.discover": "About UBISOFT+",
        "navbar.links.store": "Store",
        "navbar.links.news": "News",
        "navbar.links.forum": "Forum",
        "navbar.links.support": "Support",
        "navbar.links.status": "My status",
        "navbar.links.featured": "Highlights",
        "navbar.links.rewards": "Redeem",
        "navbar.links.library": "All games",
        "navbar.links.benefits": "UBISOFT+ rewards",
        "navbar.links.subscription": "Manage My Subscription",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "All games",
        "heading.my_games": "Continue playing",
        "heading.popular_games": "Most popular games",
        "heading.recommended_games": "Recommended for you",
        "action.load_more_games": "Load more",
        "action.search_for_game": "Search for a game",
        "action.launch_game": "Launch game",
        "action.activate_game": "Activate game",
        "filters.brand": "Filter by Brand",
        "filters.game_name": "A - Z",
        "filters.release_date": "Release Date",
        "filters.show_all": "Show All",
        "filters.sort": "Sort by",
        "filters.all": "All",
        "filters.activated": "Activated",
        "message.no_activated_games": "No activated games match your search",
        "message.already_owned": "You already own this game",
        "message.no_available_games": "No available games match your search",
        "message.no_search_results": "No available games match your search",
        "message.error": "Sorry! There was an error processing your request",
        "message.refresh_page": "Please click here to try again",
        "message.no_subscription": "You don't have an active subscription",
        "warning.savefiles_alert.title": "Important message regarding save files",
        "warning.savefiles_alert.body": "Upgrading to the edition available on UBISOFT+ will affect your save files including your current in-game progression. If your UBISOFT+ subscription ends, you’ll need to purchase the Season Pass to load any of your save files (including your current in-game progression). For more information, please view the articles {here}.",
        "warning.savefiles_alert.body.here": "here",
        "warning.savefiles_alert.cancel": "Back",
        "warning.savefiles_alert.confirm": "Confirm",
        "warning.mobile_launch_alert.body": "{game} was added to your games. Launch Uplay on your PC to play.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "Subscription Terms",
        "footer.links.privacy_policy_label": "Privacy policy",
        "footer.links.legal_label": "Legal",
        "hero.title": "Ubisoft subscription service",
        "hero.subtitle": "Unlimited access to 100+ games | Cancel anytime",
        "hero.buttons.subscribe": "Subscribe Now",
        "hero.buttons.login": "Log in",
        "hero.buttons.browse": "View all games",
        "progression.benefits.description": "Unlock our worlds and conquer your own. We want to reward your loyalty! Get new in-game items each month.\r\nThe longer you stay on Ubisoft+, the more in-game rewards you can redeem!",
        "progression.benefit.singular.reward": "in-game item",
        "progression.benefit.plural.reward": "in-game items",
        "progression.benefit.singular.benefit": "discount",
        "progression.benefit.plural.benefit": "discounts",
        "progression.benefit.singular.booster": "booster",
        "progression.benefit.plural.booster": "boosters",
        "progression.level.subscribed_for": "A UBISOFT+ subscriber for",
        "progression.level.new_subscriber": "New subscriber",
        "progression.level.new_subscribers": "New subscribers",
        "progression.level.subscription.first_month": "1st month",
        "progression.level.subscription.starting_with_months": "{months}+ months",
        "general.date.month": "month",
        "general.date.months": "months",
        "general.date.month_remaining": "month remaining",
        "general.date.months_remaining": "months remaining",
        "rewards.monthly_rewards": "Your monthly in-game rewards",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} remaining to redeem {rewards_left} reward(s) this month",
        "rewards.current_title": "This month's rewards",
        "rewards.previous_title": "Your previous rewards",
        "rewards.upcoming_title": "Upcoming rewards",
        "rewards.none_found": "No rewards found",
        "rewards.available": "Available",
        "rewards.locked": "Locked",
        "rewards.claimed": "Redeemed",
        "rewards.claim": "Yes",
        "rewards.cancel": "Cancel",
        "rewards.confirm": "Do you want to redeem this reward?",
        "rewards.none_left": "You redeemed all of your rewards for this month",
        "rewards.already_claimed": "You already redeemed this reward",
        "rewards.claim_confirm": "This reward has been shipped to your game!",
        "rewards.close": "Got it!",
        "rewards.load_more": "Load more",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};